import Loading from 'common/components/loading/loading';
import { NumberTile, TileData } from 'features/tiles/numberTile';
import Tile from 'features/tiles/tile';
import { FC } from 'react';

const FakeTile: FC<{ tileData: TileData }> = ({ tileData }) => {
  const shouldRenderTile = true;

  return (
    <Tile className="w-full">
      {shouldRenderTile ? <NumberTile tileData={tileData} /> : <Loading />}
    </Tile>
  );
};

export default FakeTile;
